var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 86,
    viewBox: "0 0 88 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.3156 20.5368L46.1702 2.45999C44.8248 1.84667 43.3156 1.84667 41.9701 2.45999L2.82486 20.5368C1.11855 21.3438 0.00302124 23.0546 0.00302124 24.9269C0.00302124 26.7992 1.11855 28.51 2.82486 29.317L41.9702 47.394C42.6265 47.6844 43.3484 47.8459 44.0702 47.8459C44.792 47.8459 45.514 47.6844 46.1702 47.394L85.3155 29.317C87.0218 28.5099 88.1374 26.7992 88.1374 24.9269C88.1374 23.0546 87.0219 21.3438 85.3156 20.5368Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6719 40.9453C86.5184 38.5243 83.5832 37.4903 81.1255 38.622L44.0704 55.7299L7.01533 38.622C4.5544 37.4872 1.61919 38.5211 0.468846 40.9453C-0.687926 43.3663 0.369523 46.2507 2.83046 47.3856L41.9779 65.4612C42.6412 65.767 43.3558 65.9215 44.0704 65.9215C44.785 65.9215 45.4995 65.767 46.1628 65.4612L85.3103 47.3856C87.7713 46.2507 88.8287 43.3663 87.6719 40.9453Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6719 59.0205C86.5184 56.5995 83.5832 55.5655 81.1255 56.6972L44.0704 73.8082L7.01533 56.6972C4.5544 55.5624 1.61919 56.5963 0.468846 59.0205C-0.687926 61.4415 0.369523 64.3259 2.83046 65.4608L41.9779 83.5396C42.6412 83.8454 43.3558 83.9999 44.0704 83.9999C44.785 83.9999 45.4995 83.8454 46.1628 83.5396L85.3103 65.4608C87.7713 64.3259 88.8287 61.4415 87.6719 59.0205Z",
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 85.9999,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.fc0cd42a5b1dde572c5cf7ce0ed8fe27.svg";
export { ForwardRef as ReactComponent };